import { Controller, useFormContext } from "react-hook-form";

import { NcRadioGroup, NcRadioGroupProps } from "./nc-radio-group";

export interface NcFormRadioGroupProps
  extends Omit<NcRadioGroupProps, "name" | "validate" | "onBlur" | "value" | "validationBehavior"> {
  name: string; // Was optional in NcRadioGroupProps and is now required
}

export const NcFormRadioGroup = ({ name, onChange, ...props }: NcFormRadioGroupProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { name, value, onChange: formOnChange, onBlur, ref },
        fieldState: { invalid, error },
      }) => (
        <NcRadioGroup
          name={name}
          value={value}
          onChange={value => {
            formOnChange(value);
            onChange?.(value);
          }}
          onBlur={onBlur}
          validationBehavior="aria"
          isInvalid={invalid}
          error={error}
          ref={ref}
          {...props}
        />
      )}
    />
  );
};
